import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { useUser } from '..';
import { useQueryClient } from 'react-query';
import { useMsal } from "@azure/msal-react";

export default function useLogout() {
  let history = useHistory();
  const [loader, setLoader] = useState(false);
  const { setUser } = useUser();
  const queryClient = useQueryClient();
  const { instance } = useMsal();

  // logoutUser
  const logoutUser = async () => {
    console.log('logging out');
    setLoader(false);
    setUser(null);
    localStorage.removeItem('userData');
    localStorage.removeItem('webApiAccessToken');
    instance.logoutPopup();
    queryClient.clear();
    history.push('/login');
    await axios
        .post('/auth/logout', {
          timeout: 10000,
        })
        .then((res) => {

        });
  };

  return {
    logoutUser,
    loader,
  };
}
